import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdSentilinkBySignalIdOptions } from '@onefootprint/fetch-dashboard';
import { Shimmer } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useEntityId from '@/components/entities/components/details/hooks/use-entity-id';
import { useErrorMessage } from '@/components/error';
import Score from './components/score';
type SentilinkContentProps = {
  signalId: string;
};
const SentilinkContent = t0 => {
  const $ = _c(18);
  const {
    signalId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.riskSignals.drawer.sentilink"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const entityId = useEntityId();
  let t2;
  if ($[1] !== entityId || $[2] !== signalId) {
    t2 = postEntitiesByFpIdSentilinkBySignalIdOptions({
      path: {
        fpId: entityId,
        signalId
      }
    });
    $[1] = entityId;
    $[2] = signalId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      ...t2,
      staleTime: Number.POSITIVE_INFINITY
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    error
  } = useQuery(t3);
  const errorMessage = useErrorMessage(error);
  if (error) {
    let t4;
    if ($[6] !== errorMessage) {
      t4 = <p className="text-body-2 text-error">{errorMessage}</p>;
      $[6] = errorMessage;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (!data) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Shimmer height="160px" width="100%" />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  const {
    idTheft,
    synthetic
  } = data;
  let t4;
  if ($[9] !== synthetic || $[10] !== t) {
    t4 = synthetic && <Score score={synthetic.score} scoreBand={synthetic.scoreBand} reasonCodes={synthetic.reasonCodes} title={t(_temp)} />;
    $[9] = synthetic;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== idTheft || $[13] !== t) {
    t5 = idTheft && <Score score={idTheft.score} scoreBand={idTheft.scoreBand} reasonCodes={idTheft.reasonCodes} title={t(_temp2)} />;
    $[12] = idTheft;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="flex flex-col gap-5">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default SentilinkContent;
function _temp($) {
  return $.score.syntheticTitle;
}
function _temp2($_0) {
  return $_0.score.idTheftTitle;
}